import React from 'react';
import './../TradeCard.css';

const TradeCard = ({ log }) => {
  const quantityColor = log.buy_sell === '1' ? 'green' : 'red';
  //const statusText = orderStatus === '2' ? 'COMPLETE' : 'PENDING';
  const orderTransaction = log.orderTransactionType === '1' ? 'Open' : 'Close';
  const orderTransactionColor = log.orderTransactionType === '1' ? 'green' : 'red';

  const sanitizeQuotedValue = (value) => {
    if (value === null || value === undefined) return '';
    return String(value).replace(/^"+|"+$/g, '').trim();
  };

  const formatExpiryDate = (dateString) => {
    const cleanedValue = sanitizeQuotedValue(dateString);
    if (!cleanedValue) return '';

    const expiryMatch = cleanedValue.match(/^(\d{2})([A-Za-z]{3})(\d{4})$/);
    if (expiryMatch) {
      const [, day, month, year] = expiryMatch;
      return `${day}-${month.toUpperCase()}-${year}`;
    }

    const date = new Date(cleanedValue);
    if (!Number.isNaN(date.getTime())) {
      const day = String(date.getDate()).padStart(2, '0');
      const year = date.getFullYear();
      const month = date.toLocaleString('en-US', { month: 'short' }).toUpperCase();
      return `${day}-${month}-${year}`;
    }

    return cleanedValue;
  };

  const orderTypeText = (orderType, buy_sell) => {
    switch(orderType){
        case "1":
          return "MARKET";
        case "2":
          {
            switch(buy_sell){
              case "1":
                return "BUY LIMIT";
              case "2":
                return "SELL LIMIT";
            }
          }
          //return "LIMIT";
        case "3":
          return "STOP LOSS";
    }
  };

  return (
    <div className="trade-card">
        <div className="d-flex justify-content-between align-items-center">
            <h4 className="trade-scriptName">
              {sanitizeQuotedValue(log.stockName)}
              {String(log.lotVariant || '').toUpperCase() === 'MINI' && (
                <span className="lot-variant-mini">MINI</span>
              )}
            </h4>
            <div className="trade-price">{Number(log.orderPrice).toFixed(2)}</div>
        </div>
        <div className="d-flex justify-content-between align-items-center">
            {log.stockExpiry!=undefined && <span className="trade-dateTime">Expiry {formatExpiryDate(log.stockExpiry)}</span>}
            <span className='trade-dateTime'>{new Date(log.dateTime).toLocaleString()}</span>
        </div>
        <div className="d-flex justify-content-between align-items-center">
            <div className="trade-body">
                <p className={`trade-quantity ${quantityColor}`}>
                    {log.buy_sell === '1' ? `QTY:${Number(log.quantity).toFixed(2)}` : `QTY:-${Number(log.quantity).toFixed(2)}`}
                </p>
                <p className="trade-market">{orderTypeText(log.orderExecutionType, log.buy_sell)}</p>
            </div>
            <div className="trade-body">
              <span className={`trade-transaction ${orderTransactionColor}`}>{orderTransaction}</span>
            </div>
        </div>
            <div className="trade-body">
              <span style={{fontSize:'13px', textAlign:'justify', fontWeight:'600', marginTop:'5px'}}>{log.remark}</span>
            </div>
            
        
    </div>
  );
};

export default TradeCard;
